<h3 mat-dialog-title>Umstallen aus {{ gruppe?.bezeichnung }}</h3>

<div mat-dialog-content>
    <div *ngIf="!isMobile">
        <div class="one-row">
            <!--    Die Anzahl der Tiere (Anzahl verfügbare)-->
            <mat-form-field style="width: 49%" class="small-form-field">
                <mat-label
                    >Anzahl Tiere <small>(verfügbar: {{ gruppe?.anzahl_tiere_aktuell }})</small></mat-label
                >
                <input matInput type="number" [formControl]="anzahlTiereCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <!--    Das Umstalldatum-->
            <mat-form-field style="width: 49%" class="small-form-field">
                <mat-label>Umstalldatum</mat-label>
                <input matInput [matDatepicker]="picker" [formControl]="umstalldatumCtrl" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="one-row">
            <!--    Das Ausstallgewicht-->
            <mat-form-field style="width: 32%" class="small-form-field">
                <mat-label>Ausstallgewicht <small>pro Tier (kg)</small></mat-label>
                <input matInput type="number" [formControl]="ausstallgewichtProTierCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <!--    Die eingesetzte Futtermenge-->
            <mat-form-field style="width: 32%" class="small-form-field">
                <mat-label>Futtermenge <small>pro Tier (kg)</small></mat-label>
                <input matInput type="number" [formControl]="futtermengeProTierCtrl" />
            </mat-form-field>
            <span class="spacer"></span>
            <mat-form-field style="width: 32%" class="small-form-field">
                <mat-label>Futtermenge <small>Gesamt (kg)</small></mat-label>
                <input matInput type="number" [formControl]="futtermengeGesamtCtrl" />
            </mat-form-field>
        </div>

        <!--    Kontakte (Zielbetrieb auswählen)-->
        <p align="center">Umstallen innerhalb...</p>
        <div class="one-row" style="margin-top: 1.25em">
            <button
                mat-flat-button
                style="width: 49%"
                color="accent"
                [disabled]="isDisabled()"
                (click)="umstallenEigeneVvvo()"
            >
                desselben Betriebs
            </button>
            <span class="spacer"></span>
            <button
                mat-flat-button
                style="width: 49%"
                color="accent"
                [disabled]="isDisabled() || !mehrereVvvos"
                (click)="umstallenAndereVvvo()"
            >
                meiner Betriebe
            </button>
        </div>
    </div>

    <div *ngIf="isMobile">
        <!--    Die Anzahl der Tiere (Anzahl verfügbare)-->
        <mat-form-field style="width: 100%" class="small-form-field">
            <mat-label
                >Anzahl Tiere <small>(verfügbar: {{ gruppe?.anzahl_tiere_aktuell }})</small></mat-label
            >
            <input matInput type="number" [formControl]="anzahlTiereCtrl" />
        </mat-form-field>
        <!--    Das Umstalldatum-->
        <mat-form-field style="width: 100%" class="small-form-field">
            <mat-label>Umstalldatum</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="umstalldatumCtrl" readonly />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field style="width: 100%" class="small-form-field">
            <mat-label>Ausstallgewicht <small>pro Tier (kg)</small></mat-label>
            <input matInput type="number" [formControl]="ausstallgewichtProTierCtrl" />
        </mat-form-field>
        <mat-form-field style="width: 100%" class="small-form-field">
            <mat-label>Eingesetzte Futtermenge <small>pro Tier (kg)</small></mat-label>
            <input matInput type="number" [formControl]="futtermengeProTierCtrl" />
        </mat-form-field>
        <mat-form-field style="width: 100%" class="small-form-field">
            <mat-label>Futtermenge <small>Gesamt (kg)</small></mat-label>
            <input matInput type="number" [formControl]="futtermengeGesamtCtrl" />
        </mat-form-field>
        <p align="center">Umstallen innerhalb...</p>
        <button
            mat-flat-button
            style="width: 100%; margin-top: 12px"
            color="accent"
            [disabled]="isDisabled()"
            (click)="umstallenEigeneVvvo()"
        >
            desselben Betriebs
        </button>
        <button
            mat-flat-button
            style="width: 100%; margin-top: 12px"
            color="accent"
            [disabled]="isDisabled() || !mehrereVvvos"
            (click)="umstallenAndereVvvo()"
        >
            meiner Betriebe
        </button>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Schließen</button>
</div>
